<template>
  <div class="membership-page">
    <h1>月票與會員</h1>
    <p>这里是月票與會員页面的内容。您可以在此查看会员权益和购买月票。</p>
  </div>
</template>

<script>
export default {
  name: 'MembershipPage',
}
</script>

<style scoped>
.membership-page {
  padding: 20px;
}
</style>
